<template>
  <div class="wrapper page-covid">
    <div class="content">
      <div>
        <v-btn height="69" :ripple="false" class="creez-button">
          <span class="creez-button-text">{{ hashtagTitle }}</span>
        </v-btn>
      </div>
      <div class="texts-wrapper">
        <div class="creez-title-wrapper">
          <span v-html="title" class="creez-title" />
        </div>
        <div class="creez-subtitle-wrapper">
          <span v-html="subtitle" class="creez-subtitle" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    hashtagTitle: '#CreezChezVous',
    title: 'MWM vous accompagne<br />pendant le confinement',
    subtitle: 'en mettant gratuitement à disposition ses applications d’apprentissage de la musique',
  }),
};
</script>

<style scoped lang="scss">
@media (max-width: 960px) {
  .creez-button {
    width: 250px!important;
    height: 60px!important;
  }

  .creez-button-text {
    font-size: 22px!important;
  }

  .creez-title-wrapper {
    margin-top: 3rem!important;
  }

  .creez-title {
    font-size: 36px!important;
  }

  .creez-subtitle-wrapper {
    margin-top: 1rem!important;
  }

  .creez-subtitle {
    font-size: 14px!important;
  }

  .texts-wrapper {
    width: 80%!important;
  }
}

.wrapper {
  display: table;
  width: 100%;
  height: 80vh;
  background-size: cover;
  background-position: center center;
}

.page-covid {
  background-image: url(https://storage.googleapis.com/mwm-website-v2-content/covid/page-covid.jpg), linear-gradient(147deg, rgba(5, 68, 55, 0.75) 26%, rgba(5, 68, 55, 0.75) 26%, rgba(4, 32, 83, 0.75) 93%);
  background-blend-mode: multiply;
}

.content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  // padding-bottom: 48px;
}

.creez-button {
  width: 287px;
  height: 69px;
  border-radius: 35px;
  box-shadow: 0 19px 36px 0 rgba(0, 0, 0, 0.64);
  text-transform: unset;
  background-image: -webkit-gradient(linear, right top, left top, color-stop(114%, #8e0eb3), color-stop(12%, #0e25a9));
  background-image: linear-gradient(to left, #8e0eb3, #0e25a9);
}

.creez-button-text {
  font-family: CenturyGothic;
  font-size: 27px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.texts-wrapper {
  width: 60%;
  margin-left: auto;
  margin-right: auto;
}

.creez-title-wrapper {
  margin-top: 4rem;
}

.creez-title {
  font-family: CenturyGothic;
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.creez-subtitle-wrapper {
  margin-top: 2rem;
}

.creez-subtitle {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

</style>
